module.exports = __webpack_public_path__ + "static/media/sara-wolff.2fc21101.md";